import { AppBar, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SubmitButton,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { EnhancedButtonPrimeReact } from "./EnhancedButtonPrimeReact";
import { IAppState } from "../../store/reducers";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { useSelector } from "react-redux";

export interface IBasicSetupFormToolbar {
	pageTitle: string;
	onResetClicked?: () => void;
	onDeleteClicked?: () => void;
	isSubmitting?: boolean;
	id?: any;
}

export const BasicSetupFormToolbar: FC<IBasicSetupFormToolbar> = ({
	pageTitle,
	onResetClicked,
	onDeleteClicked,
	isSubmitting = false,
	id,
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#F7F7F7",
				paddingY: isMobile ? 0 : "10px",
				boxShadow: "none",
				zIndex: theme.zIndex.appBar + 1,
				position: "sticky",
				top: subMenuVisibility ? "112px" : "64px",
				// top: "112px",
			}}
		>
			<Toolbar
				sx={{
					// paddingTop: { sm: 1.75, md: 1.75, lg: 1.75, xl: 1.75 },
					// paddingBottom: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingLeft: { xs: 0.2, sm: 1, md: 1, lg: 1, xl: 1 },
					paddingRight: { xs: 0.2, sm: 1, md: 1, lg: 1, xl: 1 },
					minHeight: { sm: "48px", md: "48px", lg: "48px", xl: "48px" },
					fontWeight: "700",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<div style={{ fontSize: isMobile ? "1rem" : "1.5rem", fontWeight: "bold" }}>
					{pageTitle}
				</div>
				<div>
					<EnhancedButtonPrimeReact
						label="Submit"
						loading={isSubmitting}
						type="submit"
						// icon="pi pi-check"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Success}
					/>
					{onResetClicked && (
						<EnhancedButtonPrimeReact
							// icon="pi pi-plus"
							label="Reset"
							raised
							onClickHandler={onResetClicked}
							style={{ marginLeft: isMobile ? "5px" : "1rem" }}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
						/>
					)}
					{onDeleteClicked && (
						<EnhancedButtonPrimeReact
							// icon="pi pi-trash"
							label="Delete"
							raised
							onClickHandler={onDeleteClicked}
							style={{ marginLeft: isMobile ? "5px" : "1rem" }}
							severity={EnhancedButtonPrimeReactSeverity.Danger}
							disabled={!id ? true : false}
						/>
					)}
				</div>
			</Toolbar>
		</AppBar>
	);
};
